import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { CustomerDashboardService } from '../../services/customer-dashboard.service';

@Component({
  selector: 'fury-customer-side-menu',
  templateUrl: './customer-side-menu.component.html',
  styleUrls: ['./customer-side-menu.component.scss']
})
export class CustomerSideMenuComponent implements OnInit, OnChanges {
  panelOpenState = false;
  @Input() userData: any
  @Input() fetchUser: boolean = false;
  ngUnsubscribe = new Subject<void>();
  userId = "";
  customerStatus = "";
  statusLight!: any;
  constructor(private apiService: ApiService,
    private activateRoute: ActivatedRoute,
    public commonService: CommonService,
    private customerDashboardService: CustomerDashboardService
  ) { }

  ngOnInit(): void {
    this.userId = this.activateRoute.snapshot.params["id"];
    if (this.userId) {
      this.getUserData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.fetchUser && changes?.fetchUser.currentValue === true) {
      this.getUserData();
    }
  }

  getUserData() {
    this.apiService
      .get(endpoints.customerDashboard.getUser(this.userId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          this.userData = res.body?.user;
          this.statusLight = res.body?.statusLight;
          this.customerStatus = res.body?.customerStatus;
          this.customerDashboardService.setUserInfo(this.userData);
        }
      });
  }

  get userPlace() {
    if (!this.userData?.address) return '...';
    return this.userData?.address?.streetAddress, this.userData?.address?.state, this.userData?.address?.city, this.userData?.address?.zipCode
  }
}


